define(function (require, exports, module) {
    'use strict';

    var { toNDigits } = require('lib/bytes');
    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     * @param {number} limit – in bytes
     */
    function PublicFileSizeLimit(stack, source, limit) {
        UploadFail.apply(this, arguments);

        limit = toNDigits(limit, 3).value;
        this.message = this.message.replace('{LIMIT}', limit);
    }

    PublicFileSizeLimit.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: PublicFileSizeLimit,
        className: 'PublicFileSizeLimit',
        radarName: 'fail_{SOURCE}_public-file-size-limit',
        message: 'Размер загружаемых файлов не должен превышать {LIMIT}',
    });

    module.exports = PublicFileSizeLimit;
});
